import { useRef, type ReactNode } from "react"
import Box from "@mui/material/Box"
import IconButton from "@mui/material/IconButton"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"

// Horizontal scroll-snap row: swipe on touch, arrow buttons on desktop
const Carousel = ({ children, label }: { children: ReactNode, label: string }) => {
	const ref = useRef<HTMLDivElement>(null)
	const scroll = (dir: number) => ref.current?.scrollBy({ left: dir * ref.current.clientWidth * .8, behavior: "smooth" })
	const arrow = { display: { xs: "none", md: "flex" }, position: "absolute", top: "40%", zIndex: 1, bgcolor: "#fff", boxShadow: "0 4px 14px rgba(43,45,66,.15)", "&:hover": { bgcolor: "#fff" } } as const

	return (
		<Box sx={{ position: "relative" }}>
			<IconButton aria-label={`Previous ${label}`} onClick={() => scroll(-1)} sx={{ ...arrow, left: -20 }}><ChevronLeftIcon /></IconButton>
			<Box ref={ref} role="region" aria-label={label} tabIndex={0} sx={{
				display: "flex", gap: 2.5, overflowX: "auto", scrollSnapType: "x mandatory", py: 1.5, px: .5, mx: -.5,
				scrollbarWidth: "none", "&::-webkit-scrollbar": { display: "none" },
				"& > *": { flex: { xs: "0 0 80%", sm: "0 0 300px" }, scrollSnapAlign: "start" },
			}}>
				{children}
			</Box>
			<IconButton aria-label={`Next ${label}`} onClick={() => scroll(1)} sx={{ ...arrow, right: -20 }}><ChevronRightIcon /></IconButton>
		</Box>
	)
}

export default Carousel
